import { formatCurrency, getFractionDigits } from '../../utils/formatCurrency';
import Money from '../Types/Money';

import Model from './Model';

type InputAmount = Readonly<{
    isValid: boolean;
    isTooLow: boolean;
    min: string;
    max: string;
}>;

type Props = Readonly<{
    paymentFee: Money;
    depositAmount: Money;
    amount: Money;
    inputAmount: InputAmount;
}>;

export default class DepositCalculatedAmounts extends Model {
    public readonly paymentFee: Money;
    public readonly depositAmount: Money;
    public readonly amount: Money;
    public readonly inputAmount: InputAmount;

    constructor({ paymentFee, depositAmount, amount, inputAmount }: Props) {
        super();

        this.paymentFee = paymentFee;
        this.depositAmount = depositAmount;
        this.amount = amount;
        this.inputAmount = inputAmount;
    }

    public static create(amount: number, currency: string): DepositCalculatedAmounts {
        const fractionDigits = getFractionDigits();
        const initialMoney = {
            amount,
            currency,
            formatted: formatCurrency(amount, fractionDigits, currency),
        };

        return new DepositCalculatedAmounts({
            paymentFee: initialMoney,
            depositAmount: initialMoney,
            amount: initialMoney,
            inputAmount: {
                isValid: false,
                isTooLow: true,
                min: '',
                max: '',
            },
        });
    }
}

export function getAmountDecimal(amount: Money) {
    return amount.amount / 100;
}
